const compressImage = (canvas, desiredSize, resolve, reject) => {
    if (!canvas || !canvas.getContext) {
        reject(new Error('Invalid canvas element'));
        return;
    }

    const minQuality = 0.1;
    const maxQuality = 1;
    let optimalBlob = null;

    // First, compress to the minimum quality to find the smallest possible size
    canvas.toBlob((minBlob) => {
        if (!minBlob) {
            reject(new Error('Compression failed: Unable to create blob at minimum quality'));
            return;
        }

        const minSize = minBlob.size / 1024; // Size in KB

        if (desiredSize < minSize) {
            // If the desired size is less than the minimum size, return the smallest possible blob
            resolve(minBlob);
            return;
        }

        // Perform binary search to find the optimal quality
        const performCompression = (lowQuality, highQuality) => {
            if (highQuality - lowQuality < 0.01) {
                // Resolve with the best blob found, even if it's not exactly the desired size
                resolve(optimalBlob || minBlob);
                return;
            }

            const quality = (lowQuality + highQuality) / 2;

            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error('Compression failed: Unable to create blob'));
                    return;
                }

                const compressedSize = blob.size / 1024; // Size in KB

                if (compressedSize <= desiredSize) {
                    optimalBlob = blob; // Store the current blob as it satisfies the size condition
                    performCompression(quality, highQuality); // Increase quality to get closer to desired size
                } else {
                    performCompression(lowQuality, quality); // Decrease quality to reduce size
                }
            }, 'image/jpeg', quality);
        };

        performCompression(minQuality, maxQuality);
    }, 'image/jpeg', minQuality);
};

const processFile = (file, desiredSize, resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            compressImage(canvas, desiredSize, resolve, reject);
        };

        img.onerror = (error) => reject(error);
    };

    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
};

const imageCompression = (file, desiredSize) => {
    return new Promise((resolve, reject) => {
        processFile(file, desiredSize, resolve, reject);
    });
};

export default imageCompression;